import Footer from "components/navigation/Footer";
import Navbar from "components/navigation/Navbar";
import Layout from "hocs/layouts/Layout";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import CategoriesHeader from "components/blog/CategoriesHeader";
import BlogList from "components/blog/BlogList";
import { fetchBlogList, fetchCategories } from "utils/apiContent";

function Blog() {
	const [categories, setCategories] = useState(null);
	const [posts, setPosts] = useState(null);
	const [count, setCount] = useState(0);
	const [next, setNext] = useState(null);
	const [previous, setPrevious] = useState(null);

	const loadBlogPage = async (page) => {
		try {
			const data = await fetchBlogList(page);
			setPosts(data.items);
			setCount(data.count);
			setNext(data.next);
			setPrevious(data.previous);
		} catch (error) {
			setPosts([]);
			setCount(0);
			setNext(null);
			setPrevious(null);
		}
	};

	useEffect(() => {
		let mounted = true;
		window.scrollTo(0, 0);
		const load = async () => {
			try {
				const [categoriesData, blogData] = await Promise.all([
					fetchCategories(),
					fetchBlogList(),
				]);
				if (!mounted) return;
				setCategories(categoriesData);
				setPosts(blogData.items);
				setCount(blogData.count);
				setNext(blogData.next);
				setPrevious(blogData.previous);
			} catch (error) {
				if (!mounted) return;
				setCategories([]);
				setPosts([]);
				setCount(0);
				setNext(null);
				setPrevious(null);
			}
		};
		load();

		return () => {
			mounted = false;
		};
	}, []);

	return (
		<Layout>
			<Helmet>
				<title>Corpoindustrial | Blog</title>
				<meta
					name="description"
					content="Corporación que agremia a los empresarios de Norte de Santander."
				/>
				<meta
					name="keywords"
					content="empresas, agremiados, norte de santander"
				/>
				<meta name="robots" content="all" />
				<link rel="canonical" href="https://corpoindustrial.co/" />
				<meta name="author" content="Corpoindustrial" />
				<meta name="publisher" content="Corpoindustrial" />

				{/* Social Media Tags */}
				<meta property="og:title" content="Corpoindustrial" />
				<meta
					property="og:description"
					content="Corporación que agremia a los empresarios de Norte de Santander."
				/>
				<meta property="og:url" content="https://corpoindustrial.co/" />
				<meta
					property="og:image"
					content="https://bafybeicwrhxloesdlojn3bxyjqnxgsagtd4sl53a7t4cn4vfe2abmybzua.ipfs.w3s.link/lightbnuilbg.jpg"
				/>

				<meta name="twitter:title" content="Corpoindustrial" />
				<meta
					name="twitter:description"
					content="Corporación que agremia a los empresarios de Norte de Santander."
				/>
				<meta
					name="twitter:image"
					content="https://bafybeicwrhxloesdlojn3bxyjqnxgsagtd4sl53a7t4cn4vfe2abmybzua.ipfs.w3s.link/lightbnuilbg.jpg"
				/>
				<meta name="twitter:card" content="summary_large_image" />
			</Helmet>
			<header className="flex justify-center">
				<Navbar />
			</header>
			<div className="pt-24">
				<CategoriesHeader categories={categories && categories} />

				<div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
					{/* We've used 3xl here, but feel free to try other max-widths based on your needs */}
					<div className="mx-auto max-w-6xl my-10">
						{/* Content goes here */}
						{posts && posts ? (
							<BlogList
								posts={posts}
								count={count}
								next={next}
								previous={previous}
								get_blog_list_page={loadBlogPage}
							/>
						) : (
							<div className="flex justify-center items-center">
								<h1 className="text-2xl text-gray-600">
									No hay publicaciones
								</h1>
							</div>
						)}
					</div>
				</div>
			</div>
			<Footer />
		</Layout>
	);
}
export default Blog;
